import { useEffect } from 'react';

import { TFormalOffers } from '@helpers/FormalOffers/formalOffers.types';
import { tracking } from '@iwoca/frontend-tracking-library';

import { FundingProgressIndicator } from '../../../../funding/fundingSteps/FundingProgessIndicator/FundingProgressIndicator';
import { RCFApprovedView } from '../../../approvedView/RCFApprovedView/RCFApprovedView';

export const RCFOfferPage = ({ offers }: { offers: TFormalOffers }) => {
    useEffect(() => {
        tracking.ampli.approvedViewVisited({
            status: 'rcf',
            offers_page_version: '1.0'
        });
    }, []);

    return (
        <>
            <FundingProgressIndicator step={1} />
            <RCFApprovedView formalOffers={offers} showOtherOffers={() => {}} />
        </>
    );
};
